// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__1LkS7","activeIcon":"Sidebar_activeIcon__3L--o","active":"Sidebar_active__2gyku","inactiveIcon":"Sidebar_inactiveIcon__1Yk1X"};